import { call, put, select } from 'redux-saga/effects';

import {
  getShipOptionList
} from 'apis/checkout';
import {
  GET_SHIP_OPTION_LIST_SUCCESS,
  SET_SHIP_OPTION_DATA_LOADING
} from 'store/ducks/shipOption/types';
import {
  getMafiaAndCredentials,
  getPurchaseId
} from 'store/ducks/readFromStore';
import { withSession } from 'store/ducks/session/sagas';

export function* workRequestShipOptionsForPurchaseId() {
  const { mafia, credentials } = yield select(getMafiaAndCredentials);
  const purchaseId = yield select(getPurchaseId);
  yield put({ type: SET_SHIP_OPTION_DATA_LOADING, payload: true });
  const { payload } = yield call(withSession, [getShipOptionList, mafia, purchaseId, credentials]);
  yield put({ type: GET_SHIP_OPTION_LIST_SUCCESS, payload });
}

export default [];
